import DescViewComponents from './descView.vue'

const descView = {
  install: function (Vue) {
    Vue.component('DescView', DescViewComponents)
  }
}

export default descView
